import globals from "@lvt/globals";
import { IconButton, Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { FC, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";

import client from "@/api/client";
import Mosaic from "@/common/components/LegacyMosaic/Mosaic";
import { MosaicData } from "@/utilities/types/mosaicData";


interface MosaicPageParams {
    mosaicId: string;
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.common.white,
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
    },
}));

const MosaicPage: FC = () => {
    const [mosaicData, setMosaicData] = useState<MosaicData | null>(null);
    const { mosaicId: mosaicIdString } = useParams<MosaicPageParams>();
    const mosaicId = parseInt(mosaicIdString, 10); // Parse in base 10
    const history = useHistory();
    const classes = useStyles();

    const onClickBackArrow = () => history.push("/");

    const onCloseCamera = (cameraId: number) => {
        if (!mosaicData?.cameras) return;

        const index = mosaicData.cameras.findIndex(c => c.cameraId === cameraId);

        if (index != null && index >= 0) {
            mosaicData.cameras.splice(index, 1);
            setMosaicData({ ...mosaicData });
        }
    };

    useEffect(() => {
        const getMosaicData = async () => {
            client.get(`${globals.userdashboard.proxyUrl}/api/vms/mosaic/${mosaicId}`)
                .then((res) => {
                    setMosaicData(res.data.data as MosaicData);
                });
        };

        if (mosaicId) {
            getMosaicData();
        }
    }, [mosaicId]);


    return (
        <>
            {/*TODO: Add loading*/}
            <div className={classes.root}>
                <Toolbar>
                    <IconButton edge="start" onClick={onClickBackArrow}>
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {mosaicData?.name ?? "loading..."}
                    </Typography>
                </Toolbar>
            </div>

            {mosaicData &&
                <div style={{ height: "calc(100vh - 64px)" }}>
                    <Mosaic
                        cameras={mosaicData.cameras.filter(camera => camera.presets.length)}
                        onCloseCamera={onCloseCamera}
                        liveUnitId={parseInt(mosaicData.id, 10)}
                    />
                </div>
            }
        </>
    );
};

export default MosaicPage;
